import type { AddressStruct, PassportData } from "@/lib/api";

const PROFILE_KEY = "crypto:profile:v1";
const ORDERS_KEY = "crypto:orders:v1";

export type KycInfo = {
  applicant_id: string | null;
  verified_at: number;
  level: string;
};

// Реферальный код из ?ref= на лендинге: клиент попадает на сайт до входа, поэтому код
// держим локально и отправляем на сервер сразу после того, как пользователь опознан.
const REF_KEY = "ttex_ref_code";

export function saveRefCode(code: string) {
  try {
    localStorage.setItem(REF_KEY, code);
  } catch {
    /* приватный режим — просто теряем код */
  }
}

export function takeRefCode(): string | null {
  try {
    const code = localStorage.getItem(REF_KEY);
    if (code) localStorage.removeItem(REF_KEY);
    return code;
  } catch {
    return null;
  }
}

export type Profile = {
  phone: string;
  email?: string;
  address?: AddressStruct;
  passport?: PassportData;
  display_name?: string;
  kyc?: KycInfo;
  last_wallet?: string;
  created_at: number;
};

function read<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

function write<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* ignore */
  }
}

export function getProfile(): Profile | null {
  return read<Profile>(PROFILE_KEY);
}

export function saveProfile(p: Profile): void {
  write(PROFILE_KEY, p);
}

export function updateProfile(patch: Partial<Profile>): void {
  const cur = getProfile();
  if (!cur) return;
  saveProfile({ ...cur, ...patch });
}

export function clearAll(): void {
  try {
    localStorage.removeItem(PROFILE_KEY);
    localStorage.removeItem(ORDERS_KEY);
  } catch {
    /* ignore */
  }
}
